export default "__VITE_ASSET__DAb6WXy$__"